/**
 *
 * EmailPreferences/Setters/Sms
 *
 */

import React from 'react'

// NPM Libraries
import Toggle from 'react-toggle'
import PropTypes from 'prop-types'
import update from 'immutability-helper'

// Graphql
import { useMutation, gql } from '@apollo/client'

// Utils
import { notify } from 'utils/notify'

const UPDATE_COMMUNICATION_PREFERENCE = gql`
	mutation updateCommunicationPreference($id: ID!, $contact_sms: JSON) {
		updateCommunicationPreference(input: { id: $id, contact_sms: $contact_sms }) {
			communication_preference {
				id
				contact_sms
			}
		}
	}
`

function SmsSetter({ communication_preference: { id, contact_sms }, sms_type, sms_title, disabled }) {
	const [mutate] = useMutation(UPDATE_COMMUNICATION_PREFERENCE, {
		onCompleted: ({ updateCommunicationPreference }) => {
			const status = updateCommunicationPreference.communication_preference.contact_sms[sms_type]

			notify({
				message: `${sms_title} SMS ${status ? 'Will Be Sent' : 'Turned Off'}.`,
			})
		},
	})

	const updateContactSmsPreferences = (value, checked) => {
		mutate({
			variables: {
				id,
				contact_sms: update(contact_sms, {
					[value]: { $set: checked },
				}),
			},
		})
	}

	return (
		<Toggle
			value={sms_type}
			checked={contact_sms[sms_type]}
			onChange={(e) => updateContactSmsPreferences(sms_type, e.target.checked)}
			disabled={disabled}
		/>
	)
}

SmsSetter.propTypes = {
	communication_preference: PropTypes.object,
	sms_type: PropTypes.string,
	sms_title: PropTypes.string,
	disabled: PropTypes.bool,
}

SmsSetter.defaultProps = {}

export default SmsSetter
